export const JANUS_CONFIG = {
    PLUGINS: {
        VIDEO_ROOM: {
            NAME: 'janus.plugin.videoroom'
        }
    }
};
